import type { Consumo, Empleado, Equipo, Medicion, RolPermiso, Sucursal, Usuario, View } from './types';

// Catálogo de tipos de sucursal. Respaldado por la tabla tipos_sucursal en
// Supabase (ver supabase.ts / TIPOS_SUCURSAL_SEED_SQL). Debe coincidir
// exactamente con los registros insertados en esa tabla.
export const TIPOS = ['Estacion de gasolina', 'Estacion de gas (GLP)', 'Oficina'];

// Tarifa interna RD$ por kWh. El usuario NUNCA la ve ni la edita.
export const TARIFA = 12.5;
export const S0: Sucursal[] = [{
  id: 's1',
  nombre: 'Plaza Central',
  direccion: 'Av. Duarte 45, Santo Domingo',
  tipo: 'Tienda retail',
  creado: Date.now() - 864e5 * 10
}, {
  id: 's2',
  nombre: 'Torre Norte',
  direccion: 'C/ 27 de Febrero 120, Santiago',
  tipo: 'Oficina',
  creado: Date.now() - 864e5 * 7
}, {
  id: 's3',
  nombre: 'Almacen Sur',
  direccion: 'Av. Independencia 88, D.N.',
  tipo: 'Almacen',
  creado: Date.now() - 864e5 * 3
}];
export const E0: Empleado[] = [{
  id: 'e1',
  nombre: 'Carlos Mendez',
  cargo: 'Tecnico iluminacion',
  sucursalId: 's1'
}, {
  id: 'e2',
  nombre: 'Ana Rodriguez',
  cargo: 'Supervisora',
  sucursalId: 's1'
}, {
  id: 'e3',
  nombre: 'Pedro Vargas',
  cargo: 'Electricista',
  sucursalId: 's2'
}, {
  id: 'e4',
  nombre: 'Laura Jimenez',
  cargo: 'Coordinadora',
  sucursalId: 's3'
}];
export const M0: Medicion[] = [{
  id: 'm1',
  sucursalId: 's1',
  punto: 'Area de caja',
  lux: 420,
  empleadoId: 'e1',
  notas: 'Fluorescente',
  fecha: Date.now() - 36e5 * 2
}, {
  id: 'm2',
  sucursalId: 's1',
  punto: 'Vitrina central',
  lux: 850,
  empleadoId: 'e2',
  notas: 'LEDs alta potencia',
  fecha: Date.now() - 36e5 * 4
}, {
  id: 'm3',
  sucursalId: 's2',
  punto: 'Pasillo principal',
  lux: 310,
  empleadoId: 'e3',
  notas: '',
  fecha: Date.now() - 36e5 * 6
}, {
  id: 'm4',
  sucursalId: 's2',
  punto: 'Seccion congelados',
  lux: 180,
  empleadoId: 'e3',
  notas: 'Requiere revision',
  fecha: Date.now() - 36e5 * 8
}, {
  id: 'm5',
  sucursalId: 's3',
  punto: 'Sala de reuniones',
  lux: 520,
  empleadoId: 'e4',
  notas: '',
  fecha: Date.now() - 36e5 * 10
}, {
  id: 'm6',
  sucursalId: 's3',
  punto: 'Recepcion',
  lux: 75,
  empleadoId: 'e4',
  notas: 'Bombillos quemados',
  fecha: Date.now() - 36e5 * 12
}];
export const EQ0: Equipo[] = [{
  id: 'eq1',
  nombre: 'Luxometro LX-200',
  serial: 'LX200-0091',
  estado: 'Disponible',
  calibracion: '2026-06-15'
}, {
  id: 'eq2',
  nombre: 'Luxometro ProLight A1',
  serial: 'PLA1-2318',
  estado: 'En uso',
  calibracion: '2026-06-22'
}, {
  id: 'eq3',
  nombre: 'Kit de medicion campo',
  serial: 'KIT-4402',
  estado: 'Mantenimiento',
  calibracion: 'Pendiente'
}];
export const ROLES0: RolPermiso[] = [{
  id: 'rol-admin',
  nombre: 'Administrador',
  descripcion: 'Control total del sistema y configuracion.',
  permisos: {
    consumo: {
      leer: true,
      editar: true,
      archivar: true
    },
    costoConsumo: {
      leer: true,
      editar: false,
      archivar: false
    },
    sucursales: {
      leer: true,
      editar: true,
      archivar: true
    },
    reportes: {
      leer: true,
      editar: true,
      archivar: false
    },
    alertas: {
      leer: true,
      editar: true,
      archivar: true
    },
    usuarios: {
      leer: true,
      editar: true,
      archivar: true
    },
    roles: {
      leer: true,
      editar: true,
      archivar: true
    },
    gas: {
      leer: true,
      editar: true,
      archivar: true
    },
    pedidos: {
      leer: true,
      editar: true,
      archivar: true
    },
    pedidosAutorizar: {
      leer: true,
      editar: false,
      archivar: false
    },
    auditoria: {
      leer: true,
      editar: false,
      archivar: false
    },
    configuracion: {
      leer: true,
      editar: true,
      archivar: false
    }
  }
}, {
  id: 'rol-supervisor',
  nombre: 'Supervisor',
  descripcion: 'Gestion operativa y revision de alertas.',
  permisos: {
    consumo: {
      leer: true,
      editar: true,
      archivar: false
    },
    costoConsumo: {
      leer: true,
      editar: false,
      archivar: false
    },
    sucursales: {
      leer: true,
      editar: true,
      archivar: false
    },
    reportes: {
      leer: true,
      editar: true,
      archivar: false
    },
    alertas: {
      leer: true,
      editar: true,
      archivar: false
    },
    usuarios: {
      leer: true,
      editar: false,
      archivar: false
    },
    roles: {
      leer: true,
      editar: false,
      archivar: false
    },
    gas: {
      leer: true,
      editar: true,
      archivar: false
    },
    pedidos: {
      leer: true,
      editar: true,
      archivar: true
    },
    pedidosAutorizar: {
      leer: true,
      editar: false,
      archivar: false
    },
    auditoria: {
      leer: true,
      editar: false,
      archivar: false
    },
    configuracion: {
      leer: false,
      editar: false,
      archivar: false
    }
  }
}, {
  id: 'rol-tecnico',
  nombre: 'Tecnico',
  descripcion: 'Registro de consumo y visitas de campo.',
  permisos: {
    consumo: {
      leer: true,
      editar: true,
      archivar: false
    },
    costoConsumo: {
      leer: false,
      editar: false,
      archivar: false
    },
    sucursales: {
      leer: true,
      editar: false,
      archivar: false
    },
    reportes: {
      leer: false,
      editar: false,
      archivar: false
    },
    alertas: {
      leer: true,
      editar: false,
      archivar: false
    },
    usuarios: {
      leer: false,
      editar: false,
      archivar: false
    },
    roles: {
      leer: false,
      editar: false,
      archivar: false
    },
    pedidos: {
      leer: true,
      editar: true,
      archivar: false
    },
    pedidosAutorizar: {
      leer: false,
      editar: false,
      archivar: false
    },
    auditoria: {
      leer: false,
      editar: false,
      archivar: false
    },
    configuracion: {
      leer: false,
      editar: false,
      archivar: false
    }
  }
}];
export const moduleCards: {
  id: View;
  title: string;
  desc: string;
  accent: string;
}[] = [{
  id: 'reportes',
  title: 'Reportes',
  desc: 'Exportar mediciones y resumenes a CSV o JSON.',
  accent: '#5BBB4A'
}, {
  id: 'alertas',
  title: 'Alertas',
  desc: 'Avisos automaticos cuando algo sale del rango.',
  accent: '#f59e0b'
}, {
  id: 'gas',
  title: 'Gas Industrial',
  desc: 'Clientes, contratos, rutas y ventas de gas.',
  accent: '#FF6B01'
}, {
  id: 'usuarios',
  title: 'Usuarios',
  desc: 'Permisos y roles del equipo.',
  accent: '#5BBB4A'
}, {
  id: 'roles',
  title: 'Roles y permisos',
  desc: 'Control de accesos por perfil del sistema.',
  accent: '#2563eb'
}, {
  id: 'auditoria',
  title: 'Auditoria',
  desc: 'Log de acciones y cambios del sistema',
  accent: '#60A5FA'
}, {
  id: 'configuracion',
  title: 'Configuracion',
  desc: 'Perfil, notificaciones, seguridad y preferencias',
  accent: '#94a3b8'
}];

// Lecturas mensuales del medidor (kWh acumulados, crecientes) por sucursal.
// La "fecha" es el primer día de cada mes hacia atrás desde hoy.
const monthStart = (monthsAgo: number) => {
  const d = new Date();
  d.setMonth(d.getMonth() - monthsAgo, 1);
  d.setHours(8, 0, 0, 0);
  return d.getTime();
};
export const C0: Consumo[] = [
// s1 — Plaza Central (consumo alto, retail)
{
  id: 'c-s1-5',
  sucursalId: 's1',
  fecha: monthStart(5),
  kwh: 120400
}, {
  id: 'c-s1-4',
  sucursalId: 's1',
  fecha: monthStart(4),
  kwh: 153800
}, {
  id: 'c-s1-3',
  sucursalId: 's1',
  fecha: monthStart(3),
  kwh: 186100
}, {
  id: 'c-s1-2',
  sucursalId: 's1',
  fecha: monthStart(2),
  kwh: 221900
}, {
  id: 'c-s1-1',
  sucursalId: 's1',
  fecha: monthStart(1),
  kwh: 254300
}, {
  id: 'c-s1-0',
  sucursalId: 's1',
  fecha: monthStart(0),
  kwh: 288860
},
// s2 — Torre Norte (oficina, consumo medio)
{
  id: 'c-s2-5',
  sucursalId: 's2',
  fecha: monthStart(5),
  kwh: 64200
}, {
  id: 'c-s2-4',
  sucursalId: 's2',
  fecha: monthStart(4),
  kwh: 82900
}, {
  id: 'c-s2-3',
  sucursalId: 's2',
  fecha: monthStart(3),
  kwh: 100100
}, {
  id: 'c-s2-2',
  sucursalId: 's2',
  fecha: monthStart(2),
  kwh: 119800
}, {
  id: 'c-s2-1',
  sucursalId: 's2',
  fecha: monthStart(1),
  kwh: 136400
}, {
  id: 'c-s2-0',
  sucursalId: 's2',
  fecha: monthStart(0),
  kwh: 154700
},
// s3 — Almacen Sur (consumo bajo, irregular)
{
  id: 'c-s3-5',
  sucursalId: 's3',
  fecha: monthStart(5),
  kwh: 31000
}, {
  id: 'c-s3-4',
  sucursalId: 's3',
  fecha: monthStart(4),
  kwh: 39600
}, {
  id: 'c-s3-3',
  sucursalId: 's3',
  fecha: monthStart(3),
  kwh: 45200
}, {
  id: 'c-s3-2',
  sucursalId: 's3',
  fecha: monthStart(2),
  kwh: 54800
}, {
  id: 'c-s3-1',
  sucursalId: 's3',
  fecha: monthStart(1),
  kwh: 60100
}, {
  id: 'c-s3-0',
  sucursalId: 's3',
  fecha: monthStart(0),
  kwh: 68400
}];

// Seed local de respaldo (sin password: ya no vive en el cliente). El seed
// real para Supabase, con contraseñas hasheadas con bcrypt, está en
// USUARIOS_SEED_SQL (src/supabase.ts).
export const U0: Usuario[] = [{
  id: 'u-admin',
  nombre: 'Administrador GETR',
  correo: 'admin@getr.do',
  rol: 'admin',
  sucursalesIds: [] // admin ve todo
}, {
  id: 'u-sup1',
  nombre: 'Ana Rodriguez',
  correo: 'ana@getr.do',
  rol: 'supervisor',
  sucursalesIds: ['s1'] // solo Plaza Central
}, {
  id: 'u-tec1',
  nombre: 'Pedro Vargas',
  correo: 'pedro@getr.do',
  rol: 'tecnico',
  sucursalesIds: ['s2', 's3'] // Torre Norte y Almacén Sur
}];